export const css = {
	statusIcon: 'ltLTfIUr',
	badgeStatusIcon: 'PYSjyg72',
	statusNotDone: '_1CzGTq_d',
	statusComplete: '_1DMpo0ap',
	statusInProgress: '_30C24OSZ',
	' _key': 'ascm-theme/ascm/book-widgets/status-icon'
};

export default css;
